import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';
import { Pluggable } from '@folio/stripes/core';

const BulkEditInstancesRoute = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      redirectTo="bulk-edit"
    >
      <FormattedMessage
        id="ui-inventory.templatesPluginNotAvailable"
        defaultMessage="Templates plugin not available"
      />
    </Pluggable>
  );
};

BulkEditInstancesRoute.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default BulkEditInstancesRoute;
